/**
 * 树形选择组件
 * @description 树形选择组件
 * @author wutao
 * @date 2020-2-21
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer } = framework_tool;
let { WizTreeSelectList } = component_tool;

class OfflineProgramCategorySelectList extends WizContainer {

    componentName = 'OfflineProgramCategorySelectList';

    _componentDidMount = () => {
        this._getData();
    };

    _getData(other = {}) {
        this.doAction({
            path: `questionType/nodeList`,
            payload: {
              key: `questionType@treeData`,
              // apiParams: {type:3},//线下课程与在线课程使用同一个分类
              apiParams: {type:1,state:1}
            }
        });
      };


    propsAndStateOnChange = {
        treeData: this._getDataOver.bind(this),
    }

    _getDataOver(nextProps, nextState) {
        if (nextProps.treeData.code == 1) {
            if(nextProps.treeData.data && (nextProps.treeData.data instanceof Array)){
                nextProps.treeData.data.forEach(data => {
                    this.giveKey(data)
                });
            }

        }
        return true;
      }

    /**给数据加key */
    giveKey(data){
        data.key = data.value;
        if(data.children && data.children instanceof Array){
            data.children.forEach(children=>{
                this.giveKey(children)
            })
        }
    }


    _render() {
        let treeData = this.props.treeData.data;

        return (
            <div style={{ height: 800, width: 800 }}>
                {treeData?
                <WizTreeSelectList
                    treeData={treeData}
                    itemProps={{
                        icon: 'unordered-list',
                        title: '培训课程分类',
                        tips: '请勾选所属培训课程分类'
                    }}
                    onChange={(selects)=>{
                        log.info('已选数据：',selects)
                    }}
                />:null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { questionType } = state;
    const treeData = modelUtils.getModelEntity(
        questionType,
      "questionType@treeData"
    );
    return {
     treeData:treeData,
    };
};

export default connect(mapStateToProps)(OfflineProgramCategorySelectList);
